













































































import { Vue, Component, Prop } from "vue-property-decorator";
import TransferButton from "../../../components/button/TransferButton.vue";
import CancelButton from "../../../components/button/CancelButton.vue";
import ReportButton from "../ui/ReportButton.vue";
import { LessonStates } from "../../../../src_server/entity/master/LessonStates";
import { Lessons } from "../../../../src_server/entity/generated/Lessons";
import {
  dayjs,
  DW_FORMAT_JA_SHORT,
  T_FORMAT,
} from "../../../../src_server/common/momentExtends";
import { routeHelper } from "../../../utils/routeHelper";

import { LessonServiceFront } from "../../../biz/LessonServiceFront";
import { Session } from "../../../utils/Session";

@Component({ components: { TransferButton, CancelButton, ReportButton } })
export default class RecentLessonStateSection extends Vue {
  @Prop({ default: "" })
  teacher_user_id!: string;

  @Prop({ default: [] })
  lessons!: Lessons[];

  get hasData() {
    return this.model.length > 0;
  }

  get isCo() {
    return Session.isCircleOBuilding();
  }

  get model() {
    const result = this.lessons.map((l) => {
      return {
        class_id: l.class_id,
        start_dt: l.start_dt,
        date: dayjs(l.start_dt).format(DW_FORMAT_JA_SHORT),
        start: dayjs(l.start_dt).format(T_FORMAT),
        end: dayjs(l.end_dt).format(T_FORMAT),
        state: l.reservation_state,
        is_recent: false,
        is_already: l.reservation_state === LessonStates.ALREADY,
        is_transfer: l.reservation_state === LessonStates.TRANSFAR,
        is_reservation: l.reservation_state === LessonStates.RESERVATION,
      };
    });

    const notYet = result.filter((i) => {
      if (!i.start_dt) return false;
      // return i.state !== LessonStates.ALREADY && dayjs(i.start_dt) > dayjs();
      return i.state !== LessonStates.ALREADY && dayjs(i.start_dt) > dayjs();
    });

    // console.log(notYet);
    let recentIndex = 0;
    if (notYet.length > 0) {
      const recent = notYet[0];
      recent.is_recent = true;
      recentIndex = result.indexOf(recent);
    }

    return result;
  }
  clickTransfer() {
    routeHelper(this, "StudentTransferRequestPage");
  }

  isPast(lesson: Lessons) {
    return dayjs(lesson.start_dt).diff(dayjs()) < 0;
  }
  async cancel(lesson: Lessons) {
    const class_id = lesson.class_id || 0;
    const biz = new LessonServiceFront();
    await biz.cancel(class_id, (class_id) => {
      this.$emit("delete", class_id);
    });
  }

  async report(class_id: number) {
    routeHelper(this, "StudentDailyReportPage", { class_id: class_id.toString() });
  }

  async message(lesson: Lessons) {
    this.$emit("message", lesson);
  }

  get reservationCount() {
    return this.model.filter((i) => i.state === LessonStates.RESERVATION).length;
  }
}
